import { browserDownload } from './download';

// referent from oversea
// https://git.leyantech.com/fed/oversea/-/blob/master/packages/main/src/lib/downloadChattt.ts
export const getChatttDownloadLink = async (
  channel?: string,
  platform?: 'Mac' | 'Win',
  arch?: 'ia32' | 'x64',
) => {
  if (!platform) {
    platform = navigator.platform.indexOf('Mac') !== -1 ? 'Mac' : 'Win';
  }
  let link =
    platform === 'Mac'
      ? (import.meta.env.VITE_CHATTT_LINK_MAC as string)
      : (import.meta.env.VITE_CHATTT_LINK_WIN as string);
  if (channel) {
    if (channel.toUpperCase() === 'EMALACCA') {
      // 马六甲渠道下载地址
      link =
        platform === 'Mac'
          ? (import.meta.env.VITE_CHATTT_LINK_MAC_EMALACCA as string)
          : (import.meta.env.VITE_CHATTT_LINK_WIN_EMALACCA as string);
    } else if (channel.startsWith('aigc_dny123')) {
      link = link.replace(/\/official\//, `/aigc_dny123/`);
    } else if (
      channel.startsWith('dny123') ||
      channel === 'f24217e76b51e10f261fdcb1c4d8ccdd' ||
      channel === '84405f71edf2715ea98ca5eeca7417f9'
    ) {
      // dny123 主渠道码
      link = link.replace(/\/official\//, `/9d7361613a1880a82d028155f3e49e57/`);
    } else if (channel.startsWith('aigc_shopee')) {
      // AI智造机 shopee 相关渠道转为
      // 渠道包 Shopee官方活动(978effed7621b7b7a73a026969df8073) 见 chattt config
      link = link.replace(/\/official\//, `/978effed7621b7b7a73a026969df8073/`);
    } else if (channel.startsWith('tkfff')) {
      link = link.replace(/\/official\//, `/tkfff/`);
    } else {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_CHATTT_CHANNEL_RECORDS}?t=${Date.now()}`,
        );
        const records = await response.json();
        const ks = Object.keys(records).map((r) => records[r]);
        const isExisted = ks.some((v) => v.key === channel);
        if (isExisted) {
          link = link.replace(/\/official\//, `/${channel}/`);
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  if (!arch) {
    // 64 位判断
    const x64Codes = [
      'x86_64',
      'x86-64',
      'Win64',
      'x64;',
      'amd64',
      'AMD64',
      'WOW64',
      'x64_64',
      'ia64',
      'sparc64',
      'ppc64',
      'IRIX64',
    ];
    for (let i = 0; i < x64Codes.length; i++) {
      if (navigator.userAgent.includes(x64Codes[i])) {
        arch = 'x64';
        break;
      }
    }
  }
  if (platform === 'Win' && arch) {
    link = link.replace('.exe', `_${arch}.exe`);
  }

  return link;
};

export const downloadChattt = async (
  channel?: string,
  platform?: 'Mac' | 'Win',
  arch?: 'ia32' | 'x64',
): Promise<void> => {
  const link = await getChatttDownloadLink(channel, platform, arch);
  browserDownload(link);
};

export const isWindows7 = () => {
  const userAgent = navigator.userAgent;
  return (
    userAgent.includes('Windows NT 6.3') ||
    userAgent.includes('Windows NT 6.2') ||
    userAgent.includes('Windows NT 6.1') ||
    userAgent.includes('Windows NT 5.2') ||
    userAgent.includes('Windows NT 5.1') ||
    userAgent.includes('Windows NT 5.01') ||
    userAgent.includes('Windows NT 5.0')
  );
};

export const downloadClient = (channel?: string) => {
  if (isWindows7()) {
    // Windows 7/8
    browserDownload(import.meta.env.VITE_CHATTT_LINK_WIN7);
  } else {
    return downloadChattt(channel);
  }
};

export const getWindowClientLink = async (channel?: string) => {
  if (isWindows7()) {
    return import.meta.env.VITE_CHATTT_LINK_WIN7 as string;
  } else {
    return await getChatttDownloadLink(channel, 'Win');
  }
};
